const DATA_QA = {
  SELECT: {
    BRANCH_SELECT: "branch-select",
  },
  BUTTON: {
    START_ANSWER: "start-answer-button",
    NEXT: "next-button",
    SELECT_SCORE: "select-score-button",
    SUBMIT: "submit-button",
    COUPON: "coupon-button",
    USE_COUPON: "use-coupon-button",
    MODAL_USE_COUPON: "modal-use-coupon-button",
  },
  INPUT: {
    FREE_TEXT: "free-text-input",
    CALENDER: "calender-input",
  },
  CHECK_BOX: {
    CHECK: "check-box",
  },
  RADIO: {
    RADIO: "radio-button",
  },
};
export default DATA_QA;
